import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const DropdownTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const TotalPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0020};
`;

export const P11dPriceWrapper = styled.div`
  display: flex;
  gap: ${(props) => props.theme.size.dynamic0020};
  flex-direction: row;
  justify-content: start;

  @media (min-width: ${Breakpoints.b560}px) {
    justify-content: end;
  }
`;
